/**
 * @documental
 * @export useSimpleTabState
 * @type
 * hook
 * @import
 * import { useSimpleTabState } from "capitalrx-components-2.0/lib/general";
 */

import { useCallback, useState } from "react";
import { SelectedTabChangeHandler } from "./SelectedTabChangeHandler";

/**
 * Uses simple in-memory tab state management, providing the current tab ID and a tab change handler.
 * @param initialSelectedTabId The optional initially selected tab ID, if not specified the first tab is selected.
 * @returns A tuple containing the currently selected tab ID and tab change handler function.
 */
export function useSimpleTabState(initialSelectedTabId?: string | null): [string | null | undefined, SelectedTabChangeHandler] {
  const [selectedTab, setSelectedTab] = useState<string | null | undefined>(initialSelectedTabId);

  const tabChangeHandler = useCallback<SelectedTabChangeHandler>((selectedTabId) => {
    setSelectedTab(selectedTabId);
  }, []);

  return [selectedTab, tabChangeHandler];
}
